import { render, staticRenderFns } from "./wageHistory.vue?vue&type=template&id=e96b5be8&scoped=true&"
import script from "./wageHistory.vue?vue&type=script&lang=js&"
export * from "./wageHistory.vue?vue&type=script&lang=js&"
import style0 from "./wageHistory.vue?vue&type=style&index=0&id=e96b5be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96b5be8",
  null
  
)

export default component.exports